import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "../../../data.service";

const valid_email_re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const valid_pc_nl = /^[1-9][0-9]{3} ?[A-Z]{2}$/;
const valid_pc_de = /^[0-9]{5}$/;
const valid_phone = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

@Component({
  selector: "lc-account-main-login-form",
  templateUrl: "./account-main-login-form.component.html",
  styleUrls: ["./account-main-login-form.component.scss"],
})
export class LoginMainAccountForm implements OnInit {
  @Input() mode: string = "create";
  @Input() super_orders: boolean = false; // allow orders for other users ....
  @Input() cart_empty: boolean = true; // there are no products in the cart ....
  @Input() qr_code: string;
  @Input() activation_code: string;

  @Output() resetCart: EventEmitter<any> = new EventEmitter();

  // submit_button_text: string = 'Account aanmaken';
  order_success: boolean = false;
  // input for before logged in ...
  user_code: string;
  // user_email: string;
  user_code_type: string = "action"; // 'action or 'zip'

  user_code_po: string;
  user_code_ph: string;
  user_search: string;
  extra_search: string;
  search_country_and_code: string;
  search_country: string;
  search_country_code: string;
  max_postcode_len: number;
  // user_remark: string; // moved to dataService.order_remark

  filtered_user_list: any;
  extra_filtered_user_list: any;

  hide_users: boolean = false;
  users_loading: boolean = false;

  // user_email: string;
  user_passwd: string;
  new_user_passwd: string;

  passwd_reset_code: string;

  // before signup
  new_user: any = {};
  // dummy_user: any = {id:'0000-110011', status:'LEAD', company: 'NEW COMP', address: 'new address', postalcode: '', city: '', country:'', phone: ''};
  dummy_user: any = {
    id: "0000-110011",
    status: "LEAD",
    company: "",
    address: "",
    postalcode: "",
    city: "",
    country: "",
    cc: "",
    phone: "",
  };

  need_email: boolean = false;

  user_passwd2: string;
  passwords_equal: boolean;

  show_help_popup: boolean = false;
  show_aanmeld_popup: boolean = false;
  show_create_account: boolean = false;

  constructor(public dataService: DataService, private router: Router) { }

  ngOnChanges(changes) {
    console.debug(changes);
    if (changes["qr_code"] && this.qr_code) {
      // parse the qr_code ...
      let code_parts = this.qr_code.split(" ");
      let email_index = -1;
      let nl_pc_index = -1;
      let de_pc_index = -1;
      let phone_index = -1;
      for (let i in code_parts) {
        if (valid_email_re.test(code_parts[i])) {
          email_index = +i;
        }
        if (valid_pc_nl.test(code_parts[i])) {
          nl_pc_index = +i;
        }
        if (valid_pc_de.test(code_parts[i])) {
          de_pc_index = +i;
        }
        if (valid_phone.test(code_parts[i])) {
          phone_index = +i;
        }
      }
      let cvent_id = code_parts[0];
      let user_first_names = code_parts[1];
      for (let x = 2; x < email_index - 1; x++) {
        user_first_names += " " + code_parts[x];
      }
      this.dataService.new_user_email = code_parts[email_index];
      this.dataService.new_user_firstname = user_first_names;
      this.dataService.new_user_lastname = code_parts[email_index - 1];
      if (de_pc_index > 0) {
        this.search_country = "DE";
        this.search_country_code = "DE";
        this.user_search = code_parts[de_pc_index];
      }
      if (nl_pc_index > 0) {
        this.search_country = "NETHERLANDS";
        this.search_country_code = "NL";
        this.user_search = code_parts[nl_pc_index].slice(
          0,
          this.max_postcode_len
        );
      }
      this.search_country_and_code =
        this.search_country + "|" + this.search_country_code;
      if (phone_index > 0) {
        this.dataService.new_user_phone = code_parts[phone_index];
        // this.dataService.user_info.phone = code_parts[phone_index];
      }
      if (!!this.user_search) {
        this.max_postcode_len = this.dataService.postalcode_len[
          this.search_country
        ];
        this.user_search = this.user_search.slice(0, this.max_postcode_len);
        this.update_search();
      }
    }
  }

  ngOnInit() {
    if (window.location.href.indexOf("/activate") > -1) {
      this.check_code(this.activation_code);
    }
    if (!!this.dataService.know_countries) {
      this.search_country = this.dataService.know_countries[0].name;
      this.search_country_code = this.dataService.know_countries[0].code;
      this.search_country_and_code =
        this.search_country + "|" + this.search_country_code;

      this.max_postcode_len = this.dataService.postalcode_len[
        this.search_country
      ];
    }
    if (
      !!this.dataService.current_language &&
      this.dataService.current_language === "de"
    ) {
      this.dataService.send_order_email = false;
    }
  }

  user_code_is_valid() {
    let valid_code = false;
    if (!!this.user_code) {
      valid_code = this.user_code.length == 11 && this.user_code[4] == "-";
    } else {
      valid_code =
        !!this.user_code_po &&
        this.user_code_po.length > 3 &&
        !!this.user_code_ph &&
        this.user_code_ph.length >= 6;
    }
    if (this.mode === "order") {
      if (this.super_orders) {
        if (!!this.cart_empty) {
          return (
            !!this.dataService.user_info &&
            (this.dataService.expo_demo || !!this.dataService.order_remark)
          );
        } else {
          // cart is not empty we need a valid email
          return (
            !!this.dataService.user_info &&
            !!this.dataService.new_user_email &&
            valid_email_re.test(this.dataService.new_user_email)
          );
        }
      }
      return (
        valid_code &&
        !this.cart_empty &&
        !!this.dataService.new_user_email &&
        valid_email_re.test(this.dataService.new_user_email)
      );
    } else {
      return valid_code;
    }
  }

  update_filter() {
    this.extra_filtered_user_list = this.filtered_user_list.filter((s) => {
      if (!!s.status && s.status.startsWith("DE")) return false;
      if (!!this.dataService.know_countries && this.dataService.know_countries.length > 0) {
        // hide other countries only if needed
        if (!!this.search_country && s.country.toUpperCase() !== this.search_country.toUpperCase()) return false;
      }
      if (!this.extra_search) return true;
      return JSON.stringify(s).toLowerCase().indexOf(this.extra_search.toLowerCase()) > -1;
    });
  }

  update_search() {
    [
      this.search_country,
      this.search_country_code,
    ] = this.search_country_and_code.split("|");
    if (!!this.dataService.postalcode_len[this.search_country]) {
      this.max_postcode_len = this.dataService.postalcode_len[
        this.search_country
      ];
    }
    if (!!this.user_search && this.user_search.length > 2) {
      this.users_loading = true;
      this.hide_users = false;
      this.dataService
        .getUsersForPostalcode(this.user_search, this.search_country)
        .subscribe(
          (users) => {
            if (!!users) {
              this.filtered_user_list = users;
              this.extra_filtered_user_list = users;
              this.update_filter();
            } else {
              this.filtered_user_list = [];
              this.extra_filtered_user_list = [];
            }
            this.users_loading = false;
          },
          (error) => {
            this.filtered_user_list = [];
            this.users_loading = false;
          }
        );
      this.dummy_user.postalcode = this.user_search;
      this.dummy_user.country = this.search_country;
      this.dummy_user.cc = this.search_country_code;

      this.dummy_user.id = this.user_search + "-110011";
      if (!!this.filtered_user_list && this.filtered_user_list.length > 0) {
        this.dummy_user.city = this.filtered_user_list[0].city;
      } else {
        this.dummy_user.city = "";
      }
    }
  }

  select_user(user) {
    if (user.status != undefined && user.status === 'Gone Fishing') return; // cannot select
    this.user_code_po = user.id.split("-")[0];
    this.user_code_ph = user.id.split("-")[1];
    this.dataService.new_user_email = user.email;
    // if( !!user.id ){
    //   this.dataService.new_user_fake_email = user.id + '@anonymous.orders.de';
    // }
    this.hide_users = true;
    this.dataService.set_user(user);
    this.need_email = user.id === this.dummy_user.id;

    this.dataService.send_order_email = true; //this.need_email;
    this.dataService.need_email_and_phone = this.need_email;
  }
  // add_new_user(){
  //   this.user_code_po = this.user_search;
  //   this.user_code_ph = '110011';
  //   this.dataService.new_user_email = user.email;
  //   this.hide_users = true;
  //   this.dataService.user_info = {...this.dummy_user};
  // }

  clear_user_and_cart() {
    this.clear_user();
    this.resetCart.emit();
  }

  clear_user() {
    this.dataService.new_user_email = null;

    this.dataService.send_order_email =
      this.dataService.current_language !== "de";
    this.dataService.new_user_fake_email = null;
    // this.dataService.use_anon_email = false;

    this.dataService.new_user_phone = null;
    this.dataService.order_remark = null;
    this.dataService.new_user_lastname = null;
    this.dataService.new_user_firstname = null;
    this.dataService.expo_demo = false;

    this.order_success = false;
    this.user_search = null;

    this.dataService.user_info = null;
  }

  check_user_code(mode?: string) {
    this.user_code_type = mode || "action";
    if (!!this.user_code) {
      return this.check_code(this.user_code);
    }
    let code = this.user_code_po.trim();

    if (this.dataService.main_country == "de") {
      code = code.slice(-4); // LAST 4 !!
    } else {
      if (this.dataService.main_country == "GB") {
        code = code.replace(" ", ""); // ALL
      } else {
        if (this.dataService.main_country == "NL") {
          code = code.slice(0, 4); // FIRST 4
        }
      }
    }
    code += "-" + this.user_code_ph;
    return this.check_code(code);
  }

  // this function takes the user code and sets user status. Returns a result or error from the server
  check_code(code) {
    this.dataService.getUserForCode(code).subscribe(
      (client) => {
        console.log(client);

        if (!!client.error) {
          if (this.user_code_type == "zip") {
            this.dataService.presentMessage(
              "Deze combinatie is niet bij ons bekend.",
              "error"
            );
          } else {
            this.dataService.presentMessage(
              "Oeps. Het lijkt erop dat deze actiecode niet bestaat.",
              "error"
            );
          }
        } else {
          this.dataService.user_info = { ...client };
          this.dataService.saveUserInfo(this.dataService.subuser_info);
          if (this.mode == "create") {
            try {
              window["track_event"]({
                name: "interaction",
                description: "create_account",
              });
            } catch (e) { }
            if (!!client.language && !this.new_user.language) {
              this.new_user.language = client.language;
              this.dataService.set_language(client.language.toLowerCase());
            }
            this.show_create_account = true
            // this.router.navigate(["/account/create"]);
          }
          if (this.mode == "order") {
            this.dataService
              .postOrder(this.dataService.new_user_email)
              .subscribe(
                (result) => {
                  console.log(result);
                  this.order_success = true;
                  if (result.items.length > 0) {
                    this.dataService.presentMessage(
                      "Uw bestelling is succesvol geplaatst!",
                      "success",
                      0
                    );
                  } else {
                    this.dataService.presentMessage(
                      "Uw opmerking is succesvol verstuurd!",
                      "success",
                      0
                    );
                  }

                  // reset remarks and other order fields
                  this.dataService.order_remark = null;
                  this.dataService.new_user_lastname = null;
                  this.dataService.new_user_firstname = null;
                  this.dataService.new_user_email = null;
                  this.dataService.expo_demo = false;
                },
                (err) => {
                  console.log(err);
                  this.dataService.presentMessage(
                    "Oeps. Er is iets fout gegaan tijdens het versturen van uw bestelling. Probeer het nogmaals of neem contact op met de eigenaar van de app als dit probleem zich voor blijft doen.",
                    "error",
                    0
                  );
                }
              );
          }
        }
      },
      (err) => {
        this.dataService.presentMessage(
          "Oeps. Het lijkt er op dat er iets mis is gegaan bij het controleren van de code. Weet je zeker dat de code juist is?",
          "error",
          0
        );
      },
      () => {
        console.debug("done getting code information");
        // this.goto_shop();
      }
    );
  }

  show_popup(type: string) {
    if (type === "aanmelden") this.show_aanmeld_popup = true;
    if (type === "help") this.show_help_popup = true;
  }

  close_popup(type: string) {
    if (type === "aanmelden") this.show_aanmeld_popup = false;
    if (type === "help") this.show_help_popup = false;
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-main-login-form/account-main-login-form.component.ts